import { render } from "./CreateAvrFromK2svModal.vue?vue&type=template&id=2c0459b3&scoped=true"
import script from "./CreateAvrFromK2svModal.vue?vue&type=script&lang=js"
export * from "./CreateAvrFromK2svModal.vue?vue&type=script&lang=js"

import "./CreateAvrFromK2svModal.vue?vue&type=style&index=0&id=2c0459b3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0459b3"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
